export default __webpack_public_path__ + "static/media/github.65a029dd.png";